// extracted by mini-css-extract-plugin
export default {"container":"M2-z"};